"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventNameClsMap = exports.DEFAULT_EVENT_MANAGER_OPTIONS = exports.EMPTY_ARRAY = exports.REMOTE_NEW_CHANGES = exports.defaultEventListenerOptions = exports.EventSourceTypeEnums = exports.EventAtomTypeEnums = exports.EventRealTypeEnums = exports.OPEventNameEnums = void 0;
const datasheet_1 = require("./events/datasheet");
/**
 * Before defining a new event, declare it below
 */
var OPEventNameEnums;
(function (OPEventNameEnums) {
    OPEventNameEnums["FieldUpdated"] = "FieldUpdated";
    OPEventNameEnums["CellUpdated"] = "CellUpdated";
    OPEventNameEnums["RecordCreated"] = "RecordCreated";
    OPEventNameEnums["RecordDeleted"] = "RecordDeleted";
    OPEventNameEnums["RecordUpdated"] = "RecordUpdated";
    OPEventNameEnums["RecordMetaUpdated"] = "RecordMetaUpdated";
    OPEventNameEnums["RecordCommentUpdated"] = "RecordCommentUpdated";
    OPEventNameEnums["FormSubmitted"] = "FormSubmitted";
    OPEventNameEnums["NeedCacheToDb"] = "NeedCacheToDb";
})(OPEventNameEnums = exports.OPEventNameEnums || (exports.OPEventNameEnums = {}));
var EventRealTypeEnums;
(function (EventRealTypeEnums) {
    EventRealTypeEnums["VIRTUAL"] = "VIRTUAL";
    EventRealTypeEnums["REAL"] = "REAL";
    EventRealTypeEnums["ALL"] = "ALL";
})(EventRealTypeEnums = exports.EventRealTypeEnums || (exports.EventRealTypeEnums = {}));
var EventAtomTypeEnums;
(function (EventAtomTypeEnums) {
    EventAtomTypeEnums["ATOM"] = "ATOM";
    EventAtomTypeEnums["COMB"] = "COMB";
})(EventAtomTypeEnums = exports.EventAtomTypeEnums || (exports.EventAtomTypeEnums = {}));
var EventSourceTypeEnums;
(function (EventSourceTypeEnums) {
    EventSourceTypeEnums["LOCAL"] = "LOCAL";
    EventSourceTypeEnums["REMOTE"] = "REMOTE";
    EventSourceTypeEnums["ALL"] = "ALL";
})(EventSourceTypeEnums = exports.EventSourceTypeEnums || (exports.EventSourceTypeEnums = {}));
/**
 * When listening for events, you can pass in option parameters.
 * By default, all events are subscribed, and the event is triggered after the event op apply to the store.
 */
exports.defaultEventListenerOptions = {
    realType: EventRealTypeEnums.ALL,
    sourceType: EventSourceTypeEnums.ALL,
    beforeApply: false,
};
exports.REMOTE_NEW_CHANGES = 'REMOTE_NEW_CHANGES';
exports.EMPTY_ARRAY = [];
exports.DEFAULT_EVENT_MANAGER_OPTIONS = {
    enableVirtualEvent: false,
    enableCombEvent: false,
    enableEventComplete: false
};
// Mapping relationship between event name and event definition class
exports.EventNameClsMap = {
    // cell
    [OPEventNameEnums.CellUpdated]: datasheet_1.datasheetEvent.OPEventCellUpdated,
    // field
    [OPEventNameEnums.FieldUpdated]: datasheet_1.datasheetEvent.OPEventFieldUpdated,
    // record
    [OPEventNameEnums.RecordCommentUpdated]: datasheet_1.datasheetEvent.OPEventRecordCommentUpdated,
    [OPEventNameEnums.RecordMetaUpdated]: datasheet_1.datasheetEvent.OPEventRecordMetaUpdated,
    [OPEventNameEnums.RecordCreated]: datasheet_1.datasheetEvent.OPEventRecordCreated,
    [OPEventNameEnums.RecordDeleted]: datasheet_1.datasheetEvent.OPEventRecordDeleted,
    [OPEventNameEnums.RecordUpdated]: datasheet_1.datasheetEvent.OPEventRecordUpdated,
};
//# sourceMappingURL=const.js.map